var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack202({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.73,11v1.53H5a4,4,0,0,1,.56-1.64A10.79,10.79,0,0,1,7.38,8.82,11.32,11.32,0,0,0,8.74,7.41a1.77,1.77,0,0,0,.34-1,1.17,1.17,0,0,0-.29-.84A1.1,1.1,0,0,0,8,5.26a1.11,1.11,0,0,0-.82.31,1.55,1.55,0,0,0-.35,1L5.16,6.44a2.63,2.63,0,0,1,.92-1.95A3,3,0,0,1,8,3.9a2.83,2.83,0,0,1,2,.68,2.27,2.27,0,0,1,.72,1.71,3.15,3.15,0,0,1-.2,1.1,4.51,4.51,0,0,1-.66,1.1,11.38,11.38,0,0,1-1.08,1.1c-.52.47-.85.79-1,.95a2.66,2.66,0,0,0-.34.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack202);
export default __webpack_public_path__ + "static/media/Symbolpack_2_02.7b95aa338a6d9e7a625a931205da8d07.svg";
export { ForwardRef as ReactComponent };